exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.breadcrumb { background-color: inherit }\r\n.breadcrumb a { color: white }\r\n.breadcrumb a:hover { cursor: pointer; color: #ffff33 }\r\n.breadcrumb>.active { color: #ffff33 }\r\n\r\nul.breadcrumb { padding: 0 0 0 5px; margin: 0; list-style: none; font-size: 16px;}\r\nul.breadcrumb > li { display: inline-block; vertical-align: middle; }\r\n.breadcrumb > li + li:before { padding: 0 4px 0 8px; color: #ccc; content: \">\"; }\r\n\r\na.home { vertical-align: middle; display: inline-block; line-height: 32px; }\r\na.home i { font-size: 28px; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/breadcrumb/breadcrumb.component.css
// module id = ../../../../../src/app/shared/breadcrumb/breadcrumb.component.css
// module chunks = 16